import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

var Label = function Label(props) {
  var labelClass = classNames(props.className, 'fs-body', 'd-block', 'c-grey-70');
  return React.createElement("label", {
    className: labelClass,
    htmlFor: props["for"]
  }, props.children);
};

Label.propTypes = {
  className: PropTypes.string,
  "for": PropTypes.string
};
Label.defaultProps = {
  className: '',
  "for": PropTypes.string
};
Label.displayName = 'Label';
export default Label;